export default __webpack_public_path__ + "static/media/GaiaLogo.a4d936e0.png";